module.exports = __webpack_public_path__ + "static/media/icon-timer.46f9a5a4.svg";